module.exports = __webpack_public_path__ + "static/media/21ECLAC27.91dec665.jpg";